import { Box, Button, Typography } from '@mui/material'
import translate from '../../../i18n/translate'
import { useIntl } from 'react-intl'

type TransactionTypeViewProps = {
  type: any;
  setType: any
}

export default function TransactionTypeView({
  type,
  setType,
}: TransactionTypeViewProps) {
  const intl = useIntl()
  return (
    <Box
      my={2}
      p={2}
      display='flex'
      flexDirection='column'
      justifyContent='center'
      width={1}
      alignItems='center'
      gap={2}
    >
      <Typography>
        {intl.formatMessage({ id: 'selectTransactionType' })}
      </Typography>
      <Box display='flex' width={1}>
        <Button
          variant='contained'
          color='warning'
          fullWidth
          onClick={() => setType('service')}
          disabled={type === 'service'}
          style={{
            borderRadius: '8px 0px 0px 8px',
            boxShadow: 'none',
            height: '42px'
          }}
          sx={{
            width: 1 / 2
          }}
        >
          {translate('transactionTypeService')}
        </Button>
        <Button
          variant='contained'
          fullWidth
          color='warning'
          onClick={() => setType('simple')}
          disabled={type === 'simple'}
          sx={{
            width: 1 / 2
          }}
          style={{
            borderRadius: '0px 8px 8px 0px',
            boxShadow: 'none',
            height: '42px'
          }}
        >
          {translate('transactionTypeSimple')}
        </Button>
      </Box>
    </Box>
  )
}
